import React from "react";
import clsx from "clsx";
import {ChevronDownIcon} from "@heroicons/react/24/solid";
import {useTranslation} from "react-i18next";

interface GroupedPackageUpsellItemOpenButtonProps {
    className?: string;
    handleToggle: () => void;
    isOptionsOpen: boolean;
    isSeller?: boolean;
}

const GroupedPackageUpsellItemOpenButton = (props: GroupedPackageUpsellItemOpenButtonProps) => {
    const {t} = useTranslation();

    return (
        <div className={clsx("md:border-l border-gray-300 flex flex-col items-center justify-center space-y-2 px-4 py-4 md:p-2", props.className)}>
            <div className="items-center w-full justify-center flex flex-col sm:flex-row sm:space-x-4">
                <div className={"w-full md:w-[180px] flex flex-col justify-center items-center"}>
                    <button
                        className={clsx(
                            "flex flex-col items-center justify-center font-medium text-black",
                            props.isSeller ? "gap-y-2" : "gap-y-6",
                        )}
                        type={"button"}
                        onClick={props.handleToggle}
                    >
                        <div
                            className={clsx(
                                "w-full leading-tight space-x-2 md:space-x-0 flex flex-col items-center justify-center",
                                props.isSeller ? "text-lg" : "text-lg xl:text-xl",
                            )}
                        >
                            <span
                                className={clsx("break-words", props.isSeller ? "" : "md:px-6")}
                            >
                                {props.isOptionsOpen ? t("Close selection") : t("Select options")}
                            </span>
                        </div>
                        <span
                            className={clsx(
                                "rounded-lg border-arbo-orange border-2 flex justify-center items-center hover:bg-opacity-90 duration-500 transition-all",
                                props.isSeller ? "h-8 w-8" : "h-8 md:h-12 w-8 md:w-12",
                                props.isOptionsOpen ? "bg-white" : "bg-arbo-orange",
                            )}
                        >
                            <ChevronDownIcon
                                className={clsx(
                                    "w-6 h-6 md:w-9 md:h-9",
                                    props.isOptionsOpen ? "rotate-180" : "",
                                )}
                            />
                        </span>
                    </button>
                </div>
            </div>
        </div>
    );
};

export default GroupedPackageUpsellItemOpenButton;